import FrequentPointsModal from './containers/frequentPointsModalContainer';

export default FrequentPointsModal;
